import {axios} from "~/plugins/axios"

const getDefaultState_Shared = () => {
  return {
    loading: false,
    alert: { showing: false },
    meta: {}, // pagination data
  }
}
const state = getDefaultState_Shared();

const getters = {
  getLoading: state => state.loading,
  alert: state => state.alert,
  meta: state => state.meta,
}

const actions = {
  setLoading({ commit }, payload) {
    commit('SET_LOADING', payload)
  },
  setError({ commit }, payload) {
    commit('SET_ERROR', payload)
  },
  setSuccess({ commit }, payload) {
    commit('SET_SUCCESS', payload)
  },
  clearSnackbar({ commit }) {
    commit('CLEAR_SNACKBAR')
  },
  setMeta({ commit }, payload) {
    switch (payload) {
      case undefined:
        commit('SET_META', {})
        break;
      default:
        if (payload) {
          payload['per_page'] = Number(payload['per_page'])
        }
        commit('SET_META', payload)
        break;
    }
  },

  getUIElements(ctx, payload) {
    const routeName = payload.routeName

    return axios.get(`/api/${routeName}/elements`)
      .then(response => response.data)
  },

  getShifts() {
    return axios.get('/api/shifts')
      .then(response => response.data)
  },

  getShiftTimeIntervals(ctx, shiftId) {
    return axios.get(`/api/shifts/${shiftId}/shift-time-intervals`)
      .then(response => response.data)
  },
}

const mutations = {
  SET_LOADING(state, payload) {
    state.loading = payload
  },

  SET_ERROR(state, payload) {
    state.alert.showing = false
    state.alert = { ...payload, status: 'error', showing: true }
  },

  SET_SUCCESS(state, payload) {
    state.alert.showing = false
    state.alert = { ...payload, status: 'success', showing: true }
  },

  CLEAR_SNACKBAR(state) {
    state.alert = { showing: false }
  },

  SET_META(state, payload) {
    state.meta = payload
  },


  RESET_STATE_SHARED (state) {
    Object.assign(state, getDefaultState_Shared())
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
